"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDashboardValues = getDashboardValues;
exports.getProtocolValues = getProtocolValues;
exports.getPortfolioValues = getPortfolioValues;
exports.getWalletValues = getWalletValues;
exports.fetchTotalTVL = fetchTotalTVL;
exports.fetchStSuiTvl = fetchStSuiTvl;
exports.fetchAlphalendMarkets = fetchAlphalendMarkets;
exports.fetchAlphaLendTvl = fetchAlphaLendTvl;
exports.fetchAllAppsTVL = fetchAllAppsTVL;
exports.fetchTVL = fetchTVL;
exports.fetchAlphafiV3PoolTVL = fetchAlphafiV3PoolTVL;
exports.fetchRewardAPR = fetchRewardAPR;
exports.fetchAprFromPoolAprData = fetchAprFromPoolAprData;
exports.fetchAPR = fetchAPR;
exports.fetchAPY = fetchAPY;
exports.fetchAPYPair = fetchAPYPair;
exports.fetchStSuiLoopingApr = fetchStSuiLoopingApr;
exports.getPortfolioAPY = getPortfolioAPY;
exports.getPortfolioTotalAmountInUSD = getPortfolioTotalAmountInUSD;
exports.getPortfolioAmountInUSD = getPortfolioAmountInUSD;
exports.getSingleAssetPortfolioAmountInUSD = getSingleAssetPortfolioAmountInUSD;
exports.getSingleAssetPortfolioAmount = getSingleAssetPortfolioAmount;
exports.getNaviLoopingPoolDebt = getNaviLoopingPoolDebt;
exports.getPortfolioAmount = getPortfolioAmount;
exports.getExchangeRate = getExchangeRate;
exports.getAlphaPortfolioAmount = getAlphaPortfolioAmount;
exports.getCurrentCetusPoolPrice = getCurrentCetusPoolPrice;
exports.getPositionRange = getPositionRange;
exports.getAlphaPortfolioAmountInUSD = getAlphaPortfolioAmountInUSD;
exports.getTotalAlphaRewardAmount = getTotalAlphaRewardAmount;
exports.getAlphaRewardAmount = getAlphaRewardAmount;
exports.getMultiTokenBalance = getMultiTokenBalance;
exports.getTokenBalance = getTokenBalance;
exports.getPoolExchangeRate = getPoolExchangeRate;
exports.collectRewardAndStakeAlpha = collectRewardAndStakeAlpha;
exports.convertAprToApy = convertAprToApy;
exports.fetchBucketTVL = fetchBucketTVL;
exports.fetchNaviTVL = fetchNaviTVL;
exports.fetchAlphalendTVL = fetchAlphalendTVL;
exports.fetchProtocolTVL = fetchProtocolTVL;
exports.circulationSupplyOfAlpha = circulationSupplyOfAlpha;
exports.fetchStSuiApr = fetchStSuiApr;
exports.fetchLeverage = fetchLeverage;
const tslib_1 = require("tslib");
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
const decimal_js_1 = require("decimal.js");
const cetus_sui_clmm_sdk_1 = require("@cetusprotocol/cetus-sui-clmm-sdk");
const bn_js_1 = tslib_1.__importDefault(require("bn.js"));
const index_js_1 = require("../index.js");
const simpleCache_js_1 = require("./simpleCache.js");
const stsui_sdk_1 = require("@alphafi/stsui-sdk");
const alphalend_sdk_1 = require("@alphafi/alphalend-sdk");
async function getDashboardValues(options, ignoreCache) {
    const [protocol, portfolio, wallet] = await Promise.all([
        getProtocolValues(ignoreCache),
        getPortfolioValues(options.address, ignoreCache),
        getWalletValues(options.address, ignoreCache),
    ]);
    return { protocol, portfolio, wallet };
}
async function getProtocolValues(ignoreCache) {
    const poolProtocolDataEntries = await Promise.all(Object.keys(alphafi_sdk_1.poolInfo).map(async (pool) => {
        if (alphafi_sdk_1.poolInfo[pool].poolId === "") {
            return [
                pool,
                {
                    apr: {
                        cetusApr: 0,
                        alphaApr: 0,
                    },
                    apy: 0,
                    tvl: "0",
                    protocolTvl: "0",
                },
            ];
        }
        return [
            pool,
            {
                apr: await fetchAPR(pool, ignoreCache),
                apy: await fetchAPY(pool, ignoreCache),
                tvl: await fetchTVL(pool, ignoreCache),
                protocolTvl: await fetchProtocolTVL(pool),
            },
        ];
    }));
    const poolProtocolData = poolProtocolDataEntries.reduce((acc, [pool, data]) => {
        acc[pool] = data;
        return acc;
    }, {});
    const tvl = await fetchAllAppsTVL(ignoreCache);
    const res = {
        totalTvl: tvl.total,
        airdropReserve: await fetchAirdropReserve({
            address: (0, alphafi_sdk_1.getConf)().AIRDROP_WALLET_ADDRESS,
        }, ignoreCache),
        stSuiApr: await fetchStSuiApr(7, false),
        stSuiTvl: tvl.stsui,
        alphaFiTvl: tvl.alphafi,
        alphaLendTvl: tvl.alphaLend,
        currentPoolPriceInfo: await getCurrentCetusPoolPrice(ignoreCache),
        positionRangeInfo: await getPositionRange(ignoreCache),
        poolProtocolData: poolProtocolData,
    };
    return res;
}
async function getPortfolioValues(address, ignoreCache) {
    const poolPortfolioDataEntries = await Promise.all(Object.keys(alphafi_sdk_1.poolInfo).map(async (pool) => {
        if (alphafi_sdk_1.poolInfo[pool].poolId === "") {
            return [pool, { poolBalance: 0, poolBalanceInUsd: "0" }];
        }
        return [
            pool,
            alphafi_sdk_1.poolInfo[pool].assetTypes.length === 1
                ? {
                    poolBalance: await getSingleAssetPortfolioAmount(pool, { address }, ignoreCache),
                    poolBalanceInUsd: await getSingleAssetPortfolioAmountInUSD(pool, { address }, ignoreCache),
                }
                : {
                    poolBalance: await getPortfolioAmount(pool, { address }, ignoreCache),
                    poolBalanceInUsd: await getPortfolioAmountInUSD(pool, { address }, ignoreCache),
                },
        ];
    }));
    const poolPortfolioData = poolPortfolioDataEntries.reduce((acc, [pool, data]) => {
        acc[pool] = data;
        return acc;
    }, {});
    const res = {
        userDeposit: await getPortfolioTotalAmountInUSD({ address }, ignoreCache),
        userApy: await getPortfolioAPY({ address }, ignoreCache),
        alphaReward: await getTotalAlphaRewardAmount({ address }, ignoreCache),
        alphaLockedBalance: await getAlphaPortfolioAmount("ALPHA", { address, isLocked: true }, ignoreCache),
        alphaLockedBalanceInUSD: await getAlphaPortfolioAmountInUSD("ALPHA", {
            address,
            isLocked: true,
        }, ignoreCache),
        alphaUnlockedBalance: await getAlphaPortfolioAmount("ALPHA", {
            address,
            isLocked: false,
        }, ignoreCache),
        alphaUnlockedBalanceInUSD: await getAlphaPortfolioAmountInUSD("ALPHA", {
            address,
            isLocked: false,
        }, ignoreCache),
        alphaTotalBalance: await getAlphaPortfolioAmount("ALPHA", { address }, ignoreCache),
        alphaTotalBalanceInUSD: await getAlphaPortfolioAmountInUSD("ALPHA", { address }, ignoreCache),
        poolPortfolioData: poolPortfolioData,
    };
    return res;
}
async function getWalletValues(address, ignoreCache) {
    const coins = Object.keys(alphafi_sdk_1.coinsList).map((coin) => alphafi_sdk_1.coinsList[coin].name);
    const walletDataEntries = await Promise.all(coins.map(async (coin) => {
        return [
            coin,
            await getTokenBalance(coin, { address }, ignoreCache),
        ];
    }));
    const walletValues = walletDataEntries.reduce((acc, [pool, data]) => {
        acc[pool] = data;
        return acc;
    }, {});
    return walletValues;
}
async function fetchAirdropReserve(options, ignoreCache) {
    let airdropReserver = 0;
    const [alphaPrice] = await (0, alphafi_sdk_1.getLatestPrices)(["ALPHA/USD"], ignoreCache);
    if (alphaPrice) {
        const balance = await getTokenBalance("ALPHA", options, ignoreCache);
        airdropReserver =
            parseInt(balance ? balance : "0") * parseFloat(alphaPrice);
    }
    return `${airdropReserver}`;
}
const totalTVLCache = new simpleCache_js_1.SimpleCache(300000);
const totalTVLPromiseCache = new simpleCache_js_1.SimpleCache(120000);
async function fetchTotalTVL(ignoreCache) {
    const cacheKey = "totalTVL";
    if (ignoreCache) {
        totalTVLCache.delete(cacheKey);
        totalTVLPromiseCache.delete(cacheKey);
    }
    // check if TVL is in cache
    const cachedTVL = totalTVLCache.get(cacheKey);
    if (cachedTVL)
        return cachedTVL;
    // check if TVL promise is in cache
    const cachedTVLPromise = totalTVLPromiseCache.get(cacheKey);
    if (cachedTVLPromise)
        return cachedTVLPromise;
    // Cache a new promise
    const cacheTVL = (async () => {
        let totalTVL = new decimal_js_1.Decimal(0);
        for (const key of Object.keys(alphafi_sdk_1.poolInfo)) {
            const poolTVL = await fetchTVL(key, ignoreCache);
            totalTVL = totalTVL.add(new decimal_js_1.Decimal(poolTVL));
        }
        return totalTVL.toString();
    })();
    // Store the promise and set the cache once it resolves successfully
    totalTVLPromiseCache.set(cacheKey, cacheTVL);
    try {
        const resolvedTVL = await cacheTVL;
        totalTVLCache.set(cacheKey, resolvedTVL);
        return resolvedTVL;
    }
    catch (e) {
        console.error("fetchTotalTVL failed");
        totalTVLPromiseCache.delete(cacheKey);
        throw e;
    }
}
async function fetchStSuiTvl(ignoreCache) {
    const cacheKey = "stSuiTVL";
    if (ignoreCache) {
        totalTVLCache.delete(cacheKey);
        totalTVLPromiseCache.delete(cacheKey);
    }
    // check if TVL is in cache
    const cachedTVL = totalTVLCache.get(cacheKey);
    if (cachedTVL)
        return cachedTVL;
    // check if TVL promise is in cache
    const cachedTVLPromise = totalTVLPromiseCache.get(cacheKey);
    if (cachedTVLPromise)
        return cachedTVLPromise;
    // Cache a new promise
    const cacheTVL = (0, stsui_sdk_1.stStuiCirculationSupply)((0, stsui_sdk_1.getConf)().LST_INFO, true);
    // Store the promise and set the cache once it resolves successfully
    totalTVLPromiseCache.set(cacheKey, cacheTVL);
    try {
        const resolvedTVL = await cacheTVL;
        totalTVLCache.set(cacheKey, resolvedTVL);
        return resolvedTVL;
    }
    catch (e) {
        console.error("fetchStSuiTVL failed");
        totalTVLPromiseCache.delete(cacheKey);
        throw e;
    }
}
const alphalendMarketsCache = new simpleCache_js_1.SimpleCache(120000);
async function fetchAlphalendMarkets(ignoreCache) {
    const cacheKey = "alphalendMarkets";
    if (ignoreCache) {
        alphalendMarketsCache.delete(cacheKey);
    }
    const cachedMarkets = alphalendMarketsCache.get(cacheKey);
    if (cachedMarkets)
        return cachedMarkets;
    const alphalendClient = new alphalend_sdk_1.AlphalendClient("mainnet", (0, alphafi_sdk_1.getSuiClient)());
    const markets = await alphalendClient.getMarketsChain();
    alphalendMarketsCache.set(cacheKey, markets);
    return markets;
}
async function fetchAlphaLendTvl(ignoreCache) {
    const alphalendClient = new alphalend_sdk_1.AlphalendClient("mainnet", (0, alphafi_sdk_1.getSuiClient)());
    const markets = await fetchAlphalendMarkets(ignoreCache);
    if (!markets) {
        console.error("couldnt fetch markets from alphalend sdk");
        return "0";
    }
    const stats = await alphalendClient.getProtocolStatsWithCachedMarkets(markets);
    return new decimal_js_1.Decimal(stats?.totalSuppliedUsd ?? 0)
        .sub(stats?.totalBorrowedUsd ?? 0)
        .toString();
}
async function fetchAllAppsTVL(ignoreCache) {
    const [alphafiTVL, stsuiTVL, alphaLendTVL] = await Promise.all([
        fetchTotalTVL(ignoreCache),
        fetchStSuiTvl(ignoreCache),
        fetchAlphaLendTvl(ignoreCache),
    ]);
    const allAppsTotalTVL = new decimal_js_1.Decimal(alphafiTVL)
        .add(new decimal_js_1.Decimal(stsuiTVL))
        .add(new decimal_js_1.Decimal(alphaLendTVL))
        .toString();
    return {
        alphafi: alphafiTVL,
        stsui: stsuiTVL,
        alphaLend: alphaLendTVL,
        total: allAppsTotalTVL,
    };
}
async function fetchTVL(poolName, ignoreCache) {
    try {
        let pool = undefined;
        let distributor = undefined;
        if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName == "NAVI" ||
            alphafi_sdk_1.poolInfo[poolName].parentProtocolName == "ALPHALEND") {
            pool = await (0, alphafi_sdk_1.getPool)(poolName, ignoreCache);
            const poolToken = alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin;
            const [priceOfCoin] = await (0, alphafi_sdk_1.getLatestPrices)([`${poolToken}/USD`], ignoreCache);
            let tvl = new decimal_js_1.Decimal(0);
            if (poolName == "NAVI-LOOP-SUI-VSUI" ||
                poolName == "NAVI-LOOP-USDC-USDT" ||
                poolName == "NAVI-LOOP-HASUI-SUI" ||
                poolName == "NAVI-LOOP-USDT-USDC" ||
                poolName === "ALPHALEND-LOOP-SUI-STSUI" ||
                poolName === "ALPHALEND-SINGLE-LOOP-TBTC" ||
                poolName === "ALPHALEND-SINGLE-LOOP-SUIBTC" ||
                poolName === "ALPHALEND-SINGLE-LOOP-XAUM") {
                const investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, ignoreCache));
                if (priceOfCoin && investor && pool) {
                    const liquidity = new decimal_js_1.Decimal(investor.content.fields.tokensDeposited);
                    const debtToSupplyRatio = new decimal_js_1.Decimal(investor.content.fields.current_debt_to_supply_ratio);
                    const tokensInvested = liquidity.mul(new decimal_js_1.Decimal(1).minus(debtToSupplyRatio.div(new decimal_js_1.Decimal(1e20))));
                    if (poolName == "NAVI-LOOP-SUI-VSUI") {
                        const [vsuiPrice] = await (0, alphafi_sdk_1.getLatestPrices)([`VSUI/USD`], ignoreCache);
                        if (vsuiPrice) {
                            tvl = new decimal_js_1.Decimal(tokensInvested).mul(vsuiPrice).div(1e9);
                        }
                    }
                    else if (poolName === "ALPHALEND-LOOP-SUI-STSUI") {
                        const [stSuiPrice] = await (0, alphafi_sdk_1.getLatestPrices)([`STSUI/USD`], ignoreCache);
                        if (stSuiPrice) {
                            tvl = new decimal_js_1.Decimal(tokensInvested).mul(stSuiPrice).div(1e9);
                        }
                    }
                    else {
                        let expo = 9;
                        if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName != "NAVI") {
                            expo = alphafi_sdk_1.coinsList[alphafi_sdk_1.loopingPoolCoinMap[poolName].supplyCoin].expo;
                        }
                        tvl = tokensInvested.div(Math.pow(10, expo)).mul(priceOfCoin);
                    }
                }
            }
            else {
                if (priceOfCoin && pool) {
                    const liquidity = new decimal_js_1.Decimal(pool.content.fields.tokensInvested);
                    const tokensInvested = liquidity.div(new decimal_js_1.Decimal(Math.pow(10, 9)));
                    tvl = tokensInvested.mul(priceOfCoin);
                }
            }
            return tvl.toString();
        }
        else if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName == "BUCKET") {
            pool = await (0, alphafi_sdk_1.getPool)(poolName, ignoreCache);
            const poolToken = alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin;
            const [priceOfCoin] = await (0, alphafi_sdk_1.getLatestPrices)([`${poolToken}/USD`], ignoreCache);
            if (priceOfCoin && pool) {
                const liquidity = new decimal_js_1.Decimal(pool.content.fields.tokensInvested);
                const tokensInvested = liquidity.div(new decimal_js_1.Decimal(Math.pow(10, alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].expo)));
                const tvl = tokensInvested.mul(priceOfCoin);
                return tvl.toString();
            }
        }
        else {
            if (alphafi_sdk_1.poolInfo[poolName].investorId === "" ||
                !alphafi_sdk_1.poolInfo[poolName].investorId) {
                console.warn(`investor id not found for poolName: ${poolName}, returning 0 TVL`);
                return "0";
            }
            if ("ALPHA" === poolName) {
                pool = await (0, alphafi_sdk_1.getPool)("ALPHA", ignoreCache);
                distributor = await (0, alphafi_sdk_1.getDistributor)(ignoreCache);
                const [priceOfAlpha] = await (0, alphafi_sdk_1.getLatestPrices)(["ALPHA/USD"], ignoreCache);
                if (pool && distributor && priceOfAlpha) {
                    const tokensInvested = new decimal_js_1.Decimal(pool.content.fields.tokensInvested);
                    const tvl = tokensInvested.div(1e9).mul(new decimal_js_1.Decimal(priceOfAlpha));
                    return tvl.toString();
                }
            }
            else if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "CETUS") {
                const cetus_pool = (await (0, alphafi_sdk_1.getCetusPool)(poolName, ignoreCache));
                const investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, ignoreCache));
                return await fetchAlphafiV3PoolTVL(poolName, cetus_pool, investor, ignoreCache);
            }
            else if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "BLUEFIN") {
                const bluefin_pool = (await (0, alphafi_sdk_1.getParentPool)(poolName, ignoreCache));
                const investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, ignoreCache));
                return await fetchAlphafiV3PoolTVL(poolName, bluefin_pool, investor, ignoreCache);
            }
        }
    }
    catch (e) {
        console.warn("Error in FetchTVL", e);
    }
    return "0";
}
async function fetchAlphafiV3PoolTVL(poolName, clmmPool, investor, ignoreCache) {
    const pool = (await (0, alphafi_sdk_1.getPool)(poolName, ignoreCache));
    const pool1 = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1;
    const pool2 = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2;
    const [priceOfCoin0, priceOfCoin1] = await (0, alphafi_sdk_1.getLatestPrices)([`${pool1}/USD`, `${pool2}/USD`], ignoreCache);
    if (priceOfCoin0 && priceOfCoin1 && clmmPool && investor && pool) {
        const liquidity = new bn_js_1.default(pool.content.fields.tokensInvested);
        const current_sqrt_price = new bn_js_1.default(clmmPool.content.fields.current_sqrt_price);
        let upper_tick = parseInt(investor.content.fields.upper_tick);
        let lower_tick = parseInt(investor.content.fields.lower_tick);
        if (Math.abs(lower_tick - Math.pow(2, 32)) < lower_tick) {
            lower_tick = lower_tick - Math.pow(2, 32);
        }
        if (Math.abs(upper_tick - Math.pow(2, 32)) < upper_tick) {
            upper_tick = upper_tick - Math.pow(2, 32);
        }
        const upper_sqrt_price = cetus_sui_clmm_sdk_1.TickMath.tickIndexToSqrtPriceX64(upper_tick);
        const lower_sqrt_price = cetus_sui_clmm_sdk_1.TickMath.tickIndexToSqrtPriceX64(lower_tick);
        const { coinA, coinB } = cetus_sui_clmm_sdk_1.ClmmPoolUtil.getCoinAmountFromLiquidity(liquidity, current_sqrt_price, lower_sqrt_price, upper_sqrt_price, false);
        let amount0 = new decimal_js_1.Decimal(coinA.toString());
        let amount1 = new decimal_js_1.Decimal(coinB.toString());
        const ten = new decimal_js_1.Decimal(10);
        amount0 = amount0.div(ten.pow(alphafi_sdk_1.coinsList[pool1].expo));
        amount1 = amount1.div(ten.pow(alphafi_sdk_1.coinsList[pool2].expo));
        if (alphafi_sdk_1.poolInfo[poolName].strategyType === "LEVERAGE-YIELD-FARMING") {
            const lyfInvestor = investor;
            amount0 = amount0.mul(new decimal_js_1.Decimal(1).minus(new decimal_js_1.Decimal(lyfInvestor.content.fields.current_debt_to_supply_ratio.fields.value).div(Math.pow(10, 18))));
            amount1 = amount1.mul(new decimal_js_1.Decimal(1).minus(new decimal_js_1.Decimal(lyfInvestor.content.fields.current_debt_to_supply_ratio.fields.value).div(Math.pow(10, 18))));
        }
        // if (poolName === "ALPHA-SUI") {
        //   amount0 = amount0.add(400000); // manually added ALPHA to cetus pool
        // }
        const tvl = amount0.mul(priceOfCoin0).add(amount1.mul(priceOfCoin1));
        return tvl.toString();
    }
    return "0";
}
async function fetchRewardAPR(poolName, ignoreCache) {
    let apr = 0;
    if (!(poolName in alphafi_sdk_1.poolInfo)) {
        return 0;
    }
    try {
        if (poolName === "ALPHA") {
            const pool = await (0, alphafi_sdk_1.getPool)("ALPHA", ignoreCache);
            const distributor = await (0, alphafi_sdk_1.getDistributor)(ignoreCache);
            if (pool && distributor) {
                const allocator = distributor.content.fields.pool_allocator;
                const tokensInvested = Number(pool.content.fields.tokensInvested);
                const target = Number(distributor.content.fields.target);
                const members = allocator.fields.members.fields.contents;
                let alphaMember = undefined;
                for (const member of members) {
                    if (member.fields.key === (0, alphafi_sdk_1.getConf)().ALPHA_POOL) {
                        alphaMember = member;
                    }
                }
                if (alphaMember) {
                    const weight = Number(alphaMember.fields.value.fields.pool_data.fields.contents[0].fields
                        .value.fields.weight);
                    const totalWeightArr = allocator.fields.total_weights.fields.contents;
                    const totalWeight = Number(totalWeightArr[0].fields.value);
                    if (totalWeight === 0 || tokensInvested === 0)
                        return 0;
                    apr =
                        (((target / 100) * 365 * weight) / totalWeight / tokensInvested) *
                            (2750000 / 4250000) *
                            100;
                }
            }
        }
        else if (Object.keys(alphafi_sdk_1.doubleAssetPoolCoinMap).includes(poolName)) {
            const distributor = await (0, alphafi_sdk_1.getDistributor)(ignoreCache);
            let clmmPool;
            if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName == "CETUS") {
                clmmPool = await (0, alphafi_sdk_1.getCetusPool)(poolName, ignoreCache);
            }
            else {
                clmmPool = await (0, alphafi_sdk_1.getParentPool)(poolName, ignoreCache);
            }
            const pool = (await (0, alphafi_sdk_1.getPool)(poolName, ignoreCache));
            let investor;
            if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName == "CETUS") {
                investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, ignoreCache));
            }
            else if (alphafi_sdk_1.poolInfo[poolName].strategyType === "LEVERAGE-YIELD-FARMING") {
                investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, ignoreCache));
            }
            else {
                investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, ignoreCache));
            }
            const tokenA = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1;
            const tokenB = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2;
            if (distributor && clmmPool && investor && pool) {
                const allocator = distributor.content.fields.pool_allocator;
                const members = allocator.fields.members.fields.contents;
                let poolMember = undefined;
                for (const member of members) {
                    if (member.fields.key == alphafi_sdk_1.poolInfo[poolName].poolId) {
                        poolMember = member;
                    }
                }
                if (poolMember) {
                    try {
                        const target = Number(distributor.content.fields.target);
                        const weight = Number(poolMember.fields.value.fields.pool_data.fields.contents[0].fields
                            .value.fields.weight);
                        const totalWeight = Number(allocator.fields.total_weights.fields.contents[0].fields.value);
                        if (totalWeight === 0)
                            return 0;
                        const [priceOfCoin0, priceOfCoin1] = await (0, alphafi_sdk_1.getLatestPrices)([
                            `${tokenA}/USD`,
                            `${tokenB}/USD`,
                        ], ignoreCache);
                        const [priceOfAlpha] = await (0, alphafi_sdk_1.getLatestPrices)(["ALPHA/USD"], ignoreCache);
                        if (priceOfCoin0 && priceOfCoin1) {
                            const liquidity = Math.floor(parseFloat(pool.content.fields.tokensInvested)).toString();
                            const current_sqrt_price = new bn_js_1.default(clmmPool.content.fields.current_sqrt_price);
                            const upperBound = 443636;
                            let lowerTick = Number(investor.content.fields.lower_tick);
                            let upperTick = Number(investor.content.fields.upper_tick);
                            if (lowerTick > upperBound) {
                                lowerTick = -~(lowerTick - 1);
                            }
                            if (upperTick > upperBound) {
                                upperTick = -~(upperTick - 1);
                            }
                            const upper_sqrt_price = cetus_sui_clmm_sdk_1.TickMath.tickIndexToSqrtPriceX64(upperTick);
                            const lower_sqrt_price = cetus_sui_clmm_sdk_1.TickMath.tickIndexToSqrtPriceX64(lowerTick);
                            const { coinA, coinB } = cetus_sui_clmm_sdk_1.ClmmPoolUtil.getCoinAmountFromLiquidity(new bn_js_1.default(liquidity), current_sqrt_price, lower_sqrt_price, upper_sqrt_price, false);
                            let amount0 = new decimal_js_1.Decimal(coinA.toString());
                            let amount1 = new decimal_js_1.Decimal(coinB.toString());
                            if (alphafi_sdk_1.poolInfo[poolName].strategyType === "LEVERAGE-YIELD-FARMING") {
                                amount0 = amount0.mul(new decimal_js_1.Decimal(1).minus(new decimal_js_1.Decimal(investor.content.fields.current_debt_to_supply_ratio.fields.value).div(Math.pow(10, 18))));
                                amount1 = amount1.mul(new decimal_js_1.Decimal(1).minus(new decimal_js_1.Decimal(investor.content.fields.current_debt_to_supply_ratio.fields.value).div(Math.pow(10, 18))));
                            }
                            // amount0 = amount0 / 10 ** coins[tokenA as CoinName].expo;
                            // amount1 = amount1 / 10 ** coins[tokenB as CoinName].expo;
                            amount0 = amount0.div(new decimal_js_1.Decimal(10 ** alphafi_sdk_1.coinsList[tokenA].expo));
                            amount1 = amount1.div(new decimal_js_1.Decimal(10 ** alphafi_sdk_1.coinsList[tokenB].expo));
                            if (priceOfAlpha) {
                                const amount0Big = new decimal_js_1.Decimal(amount0.toString());
                                const targetBig = new decimal_js_1.Decimal(target);
                                const weightBig = new decimal_js_1.Decimal(weight);
                                const totalWeightBig = new decimal_js_1.Decimal(totalWeight);
                                const priceOfAlphaBig = new decimal_js_1.Decimal(priceOfAlpha);
                                const priceOfCoin0Big = new decimal_js_1.Decimal(priceOfCoin0);
                                const amount1Big = new decimal_js_1.Decimal(amount1.toString());
                                const priceOfCoin1Big = new decimal_js_1.Decimal(priceOfCoin1);
                                if (totalWeight === 0 ||
                                    amount0Big
                                        .mul(priceOfCoin0Big)
                                        .add(amount1Big.mul(priceOfCoin1Big))
                                        .isZero()) {
                                    return 0;
                                }
                                // apr =
                                //   (((((target / (100 * 1_000_000_000)) * 365 * weight) /
                                //     totalWeight) *
                                //     parseFloat(priceOfAlpha)) /
                                //     (amount0 * Number(priceOfCoin0) +
                                //       amount1 * Number(priceOfCoin1))) *
                                //   (2_750_000 / 4_250_000) *
                                //   100;
                                apr = targetBig
                                    .div(new decimal_js_1.Decimal(100).mul(new decimal_js_1.Decimal(1000000000)))
                                    .mul(new decimal_js_1.Decimal(365))
                                    .mul(weightBig)
                                    .div(totalWeightBig)
                                    .mul(priceOfAlphaBig)
                                    .div(amount0Big
                                    .mul(priceOfCoin0Big)
                                    .add(amount1Big.mul(priceOfCoin1Big)))
                                    .mul(new decimal_js_1.Decimal(2750000).div(new decimal_js_1.Decimal(4250000)))
                                    .mul(new decimal_js_1.Decimal(100))
                                    .toNumber();
                            }
                        }
                    }
                    catch (error) {
                        console.log(`Error calculating Alpha APR for pool ${poolName}`, error);
                    }
                }
            }
        }
        else if (Object.keys(alphafi_sdk_1.singleAssetPoolCoinMap).includes(poolName)) {
            const distributor = await (0, alphafi_sdk_1.getDistributor)(ignoreCache);
            const pool = await (0, alphafi_sdk_1.getPool)(poolName, ignoreCache);
            const token = alphafi_sdk_1.singleAssetPoolCoinMap[poolName];
            if (distributor && pool) {
                const allocator = distributor.content.fields.pool_allocator;
                const members = allocator.fields.members.fields.contents;
                let poolMember = undefined;
                for (const member of members) {
                    if (member.fields.key == alphafi_sdk_1.poolInfo[poolName].poolId) {
                        poolMember = member;
                    }
                }
                if (poolMember) {
                    try {
                        const target = Number(distributor.content.fields.target);
                        const weight = Number(poolMember.fields.value.fields.pool_data.fields.contents[0].fields
                            .value.fields.weight);
                        const totalWeight = Number(allocator.fields.total_weights.fields.contents[0].fields.value);
                        if (totalWeight === 0)
                            return 0;
                        const [priceOfCoin] = await (0, alphafi_sdk_1.getLatestPrices)([`${token.coin}/USD`], ignoreCache);
                        const [priceOfAlpha] = await (0, alphafi_sdk_1.getLatestPrices)(["ALPHA/USD"], ignoreCache);
                        if (priceOfCoin) {
                            let tokensInvested = new decimal_js_1.Decimal(pool.content.fields.tokensInvested);
                            // dividing by 1e9 for every token because navi scales every token's liquidity to 1e9;
                            if (poolName === "NAVI-LOOP-SUI-VSUI" ||
                                poolName === "NAVI-LOOP-USDC-USDT" ||
                                poolName === "NAVI-LOOP-HASUI-SUI" ||
                                poolName === "NAVI-LOOP-USDT-USDC" ||
                                poolName === "ALPHALEND-LOOP-SUI-STSUI") {
                                const investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, ignoreCache));
                                if (investor) {
                                    const debtToSupplyRatio = new decimal_js_1.Decimal(investor.content.fields.current_debt_to_supply_ratio);
                                    tokensInvested = tokensInvested
                                        .mul(new decimal_js_1.Decimal(1).minus(debtToSupplyRatio.div(new decimal_js_1.Decimal(1e20))))
                                        .div(new decimal_js_1.Decimal(1e9));
                                }
                                else {
                                    tokensInvested = new decimal_js_1.Decimal(0);
                                }
                            }
                            else {
                                tokensInvested = tokensInvested.div(Math.pow(10, 9));
                            }
                            const liquidity = tokensInvested.toNumber();
                            if (priceOfAlpha) {
                                if (totalWeight === 0 || liquidity * Number(priceOfCoin) === 0)
                                    return 0;
                                apr =
                                    (((((target / (100 * 1000000000)) * 365 * weight) /
                                        totalWeight) *
                                        parseFloat(priceOfAlpha)) /
                                        (liquidity * Number(priceOfCoin))) *
                                        (2750000 / 4250000) *
                                        100;
                            }
                        }
                    }
                    catch (e) {
                        console.error("error in fetchRewardAPR", e);
                    }
                }
            }
        }
        else {
            console.log("fetchRewardAPR not implemented for poolName: " + poolName);
        }
    }
    catch (e) {
        console.error("error in fetchRewardAPR", e);
    }
    if (!apr) {
        apr = 0;
    }
    return apr;
}
async function fetchAprFromPoolAprData(poolAprData, ignoreCache) {
    let apr = 0;
    const poolName = poolAprData.alphafiSymbol;
    const rewardApr = await fetchRewardAPR(poolName, ignoreCache);
    if (poolName === "ALPHA") {
        apr = 0;
    }
    else if ([
        // for bucket buck pool
        "BUCKET-BUCK",
    ].includes(poolName)) {
        apr = poolAprData.apr;
        return { bucketApr: apr, alphaApr: rewardApr };
    }
    else if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "CETUS") {
        apr = poolAprData.apr;
        return { cetusApr: apr, alphaApr: rewardApr };
    }
    else if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "NAVI") {
        apr = poolAprData.apr;
        if (poolName === "NAVI-LOOP-SUI-VSUI") {
            const investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, ignoreCache));
            if (investor) {
                const debtToSupplyRatio = new decimal_js_1.Decimal(investor.content.fields.current_debt_to_supply_ratio);
                const debtToSupplyRatioInDecimal = debtToSupplyRatio
                    .dividedBy(1e20)
                    .toNumber();
                const vsuiApr = 2.67 / (1 - debtToSupplyRatioInDecimal);
                apr += vsuiApr;
            }
        }
        else if (poolName === "NAVI-LOOP-HASUI-SUI") {
            const investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, ignoreCache));
            if (investor) {
                const debtToSupplyRatio = new decimal_js_1.Decimal(investor.content.fields.current_debt_to_supply_ratio);
                const debtToSupplyRatioInDecimal = debtToSupplyRatio
                    .dividedBy(1e20)
                    .toNumber();
                const haSuiApr = (3.01 * debtToSupplyRatioInDecimal) /
                    (1 - debtToSupplyRatioInDecimal);
                apr += haSuiApr;
            }
        }
        return { naviApr: apr, alphaApr: rewardApr };
    }
    else if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "BLUEFIN") {
        apr = poolAprData.apr;
        return { bluefinApr: apr, alphaApr: rewardApr };
    }
    else if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "ALPHALEND") {
        apr = poolAprData.apr;
        return { alphalendApr: apr, alphaApr: rewardApr };
    }
    else {
        console.log("fetchAprFromPoolData not implemented for poolName: " + poolName);
    }
    return { cetusApr: apr, alphaApr: rewardApr };
}
const aprCache = new simpleCache_js_1.SimpleCache();
const aprPromiseCache = new simpleCache_js_1.SimpleCache();
async function fetchAPR(poolName, ignoreCache) {
    // Special case for ALPHALEND-SINGLE-LOOP-XAUM
    if (poolName === "ALPHALEND-SINGLE-LOOP-XAUM") {
        const rewardApr = await fetchRewardAPR(poolName, ignoreCache);
        return { alphalendApr: 18.12, alphaApr: rewardApr };
    }
    const apiUrl = process.env.APR_URL;
    if (!apiUrl) {
        throw Error("APR_URL env variable not set");
    }
    let poolData;
    if (ignoreCache) {
        aprCache.clear();
        aprPromiseCache.delete(apiUrl);
    }
    const cachedResponse = aprCache.get(apiUrl);
    if (cachedResponse) {
        poolData = cachedResponse;
    }
    else {
        let cachedPromise = aprPromiseCache.get(apiUrl);
        if (!cachedPromise) {
            cachedPromise = fetch(apiUrl)
                .then(async (response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = (await response.json()); // Parse the JSON response
                aprCache.set(apiUrl, data); // Cache the response
                aprPromiseCache.delete(apiUrl); // Remove the promise from the cache
                return data;
            })
                .catch((error) => {
                aprPromiseCache.delete(apiUrl); // Ensure the promise is removed on error
                throw error;
            });
            aprPromiseCache.set(apiUrl, cachedPromise);
        }
        poolData = await cachedPromise;
    }
    const targetPool = poolData.find((pool) => pool.name === poolName);
    if (targetPool) {
        return targetPool.apr;
    }
    else {
        console.error(`APR data not found for pool: ${poolName}`);
        if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "CETUS") {
            return { cetusApr: 0, alphaApr: 0 };
        }
        else if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "BLUEFIN") {
            return { bluefinApr: 0, alphaApr: 0 };
        }
        else if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "NAVI") {
            return { naviApr: 0, alphaApr: 0 };
        }
        else if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "BUCKET") {
            return { bucketApr: 0, alphaApr: 0 };
        }
        else if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "ALPHALEND") {
            return { alphalendApr: 0, alphaApr: 0 };
        }
        else {
            return { cetusApr: 0, alphaApr: 0 };
        }
    }
}
// Type guard for CetusPoolApr
function isCetusPoolApr(apr) {
    return apr.cetusApr !== undefined;
}
// Type guard for NaviPoolApr
function isNaviPoolApr(apr) {
    return apr.naviApr !== undefined;
}
// Type guard for BucketPoolApr
function isBucketPoolApr(apr) {
    return apr.bucketApr !== undefined;
}
function isBluefinPoolApr(apr) {
    return apr.bluefinApr !== undefined;
}
function isAlphalendPoolApr(apr) {
    return apr.alphalendApr !== undefined;
}
async function fetchAPY(poolName, ignoreCache) {
    const apr = await fetchAPR(poolName, ignoreCache);
    let stSuiApr = new decimal_js_1.Decimal(0);
    if (poolName === "NAVI-STSUI" ||
        poolName === "BLUEFIN-STSUI-SUI" ||
        poolName === "ALPHALEND-LOOP-SUI-STSUI" ||
        poolName === "BLUEFIN-FUNGIBLE-STSUI-SUI" ||
        poolName === "BLUEFIN-LYF-STSUI-SUI") {
        stSuiApr = new decimal_js_1.Decimal(await fetchStSuiApr(7, ignoreCache));
        if (poolName === "ALPHALEND-LOOP-SUI-STSUI") {
            const investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, false));
            let debtToSupplyRatio = new decimal_js_1.Decimal(investor.content.fields.current_debt_to_supply_ratio);
            debtToSupplyRatio = debtToSupplyRatio.div(1e20);
            stSuiApr = stSuiApr.div(new decimal_js_1.Decimal(1).sub(debtToSupplyRatio));
        }
    }
    let apy = 0;
    if (isCetusPoolApr(apr)) {
        apy = convertAprToApy(apr.cetusApr + apr.alphaApr + Number(stSuiApr));
    }
    else if (isNaviPoolApr(apr)) {
        apy = convertAprToApy(apr.naviApr + apr.alphaApr + Number(stSuiApr));
    }
    else if (isBucketPoolApr(apr)) {
        apy = convertAprToApy(apr.bucketApr + apr.alphaApr + Number(stSuiApr));
    }
    else if (isBluefinPoolApr(apr)) {
        apy = convertAprToApy(apr.bluefinApr + apr.alphaApr + Number(stSuiApr));
    }
    else if (isAlphalendPoolApr(apr)) {
        apy = convertAprToApy(apr.alphalendApr + apr.alphaApr + Number(stSuiApr));
    }
    return apy;
}
async function fetchAPYPair(poolName, ignoreCache) {
    const apr = await fetchAPR(poolName, ignoreCache);
    let apy;
    if (isCetusPoolApr(apr)) {
        apy = {
            cetusApy: convertAprToApy(apr.cetusApr),
            alphaApy: convertAprToApy(apr.alphaApr),
        };
    }
    else if (isNaviPoolApr(apr)) {
        apy = {
            naviApy: convertAprToApy(apr.naviApr),
            alphaApy: convertAprToApy(apr.alphaApr),
        };
    }
    else if (isBucketPoolApr(apr)) {
        apy = {
            bucketApy: convertAprToApy(apr.bucketApr),
            alphaApy: convertAprToApy(apr.alphaApr),
        };
    }
    else if (isBluefinPoolApr(apr)) {
        apy = {
            bluefinApy: convertAprToApy(apr.bluefinApr),
            alphaApy: convertAprToApy(apr.alphaApr),
        };
    }
    else if (isAlphalendPoolApr(apr)) {
        apy = {
            alphalendApy: convertAprToApy(apr.alphalendApr),
            alphaApy: convertAprToApy(apr.alphaApr),
        };
    }
    else {
        apy = {
            cetusApy: 0,
            alphaApy: 0,
        };
    }
    return apy;
}
async function fetchStSuiLoopingApr(poolName, ignoreCache) {
    let stSuiApr = new decimal_js_1.Decimal(0);
    stSuiApr = new decimal_js_1.Decimal(await fetchStSuiApr(7, ignoreCache));
    const investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, false));
    let debtToSupplyRatio = new decimal_js_1.Decimal(investor.content.fields.current_debt_to_supply_ratio);
    debtToSupplyRatio = debtToSupplyRatio.div(1e20);
    stSuiApr = stSuiApr.div(new decimal_js_1.Decimal(1).sub(debtToSupplyRatio));
    return stSuiApr;
}
async function getPortfolioAPY(options, ignoreCache) {
    let numerator = new decimal_js_1.Decimal(0);
    let denominator = new decimal_js_1.Decimal(0);
    for (const key of Object.keys(alphafi_sdk_1.poolInfo)) {
        const pool = key;
        if (alphafi_sdk_1.poolInfo[pool].poolId === "" ||
            pool.toString().includes("AUTOBALANCE")) {
            continue;
        }
        let stSuiApr = new decimal_js_1.Decimal(0);
        if (pool === "NAVI-STSUI" ||
            pool === "BLUEFIN-STSUI-SUI" ||
            pool === "ALPHALEND-LOOP-SUI-STSUI" ||
            pool === "BLUEFIN-LYF-STSUI-SUI") {
            stSuiApr = new decimal_js_1.Decimal(await fetchStSuiApr(7, ignoreCache));
            if (pool === "ALPHALEND-LOOP-SUI-STSUI") {
                const investor = (await (0, alphafi_sdk_1.getInvestor)(pool, false));
                let debtToSupplyRatio = new decimal_js_1.Decimal(investor.content.fields.current_debt_to_supply_ratio);
                debtToSupplyRatio = debtToSupplyRatio.div(1e20);
                stSuiApr = stSuiApr.div(new decimal_js_1.Decimal(1).sub(debtToSupplyRatio));
            }
        }
        const fetchedAPR = await fetchAPR(pool, ignoreCache);
        const poolApr = isCetusPoolApr(fetchedAPR)
            ? fetchedAPR.alphaApr + fetchedAPR.cetusApr
            : isNaviPoolApr(fetchedAPR)
                ? fetchedAPR.alphaApr + fetchedAPR.naviApr
                : isBucketPoolApr(fetchedAPR)
                    ? fetchedAPR.bucketApr + fetchedAPR.alphaApr
                    : isBluefinPoolApr(fetchedAPR)
                        ? fetchedAPR.bluefinApr + fetchedAPR.alphaApr
                        : isAlphalendPoolApr(fetchedAPR)
                            ? fetchedAPR.alphalendApr + fetchedAPR.alphaApr
                            : 0;
        let amount;
        if (alphafi_sdk_1.poolInfo[key].parentProtocolName === "NAVI" ||
            alphafi_sdk_1.poolInfo[key].parentProtocolName === "BUCKET" ||
            alphafi_sdk_1.poolInfo[key].parentProtocolName === "ALPHALEND") {
            amount = await getSingleAssetPortfolioAmountInUSD(pool, options, ignoreCache);
        }
        else if (alphafi_sdk_1.poolInfo[key].parentProtocolName === "ALPHAFI") {
            amount = await getAlphaPortfolioAmountInUSD(pool, options, ignoreCache);
        }
        else if (alphafi_sdk_1.poolInfo[key].parentProtocolName === "CETUS" ||
            alphafi_sdk_1.poolInfo[key].parentProtocolName === "BLUEFIN") {
            amount = await getPortfolioAmountInUSD(pool, options, ignoreCache);
        }
        const dapr = new decimal_js_1.Decimal(poolApr).add(stSuiApr);
        let damount = new decimal_js_1.Decimal(0);
        if (amount)
            damount = new decimal_js_1.Decimal(amount);
        numerator = numerator.add(dapr.mul(damount));
        denominator = denominator.add(damount);
    }
    if (denominator.eq(0))
        return "0";
    const portfolioAPR = numerator.div(denominator);
    const portfolioAPY = convertAprToApy(portfolioAPR.toNumber());
    return `${portfolioAPY}`;
}
async function getPortfolioTotalAmountInUSD(options, ignoreCache) {
    let portfolioTotal = new decimal_js_1.Decimal(0);
    for (const key of Object.keys(alphafi_sdk_1.poolInfo)) {
        const pool = key;
        if (alphafi_sdk_1.poolInfo[pool].poolId === "" ||
            pool.toString().includes("AUTOBALANCE")) {
            continue;
        }
        let poolPortfolio;
        if (alphafi_sdk_1.poolInfo[key].parentProtocolName === "ALPHAFI") {
            poolPortfolio = await getAlphaPortfolioAmountInUSD("ALPHA", options, ignoreCache);
        }
        else if (alphafi_sdk_1.poolInfo[key].parentProtocolName === "CETUS" ||
            alphafi_sdk_1.poolInfo[key].parentProtocolName === "BLUEFIN") {
            poolPortfolio = await getPortfolioAmountInUSD(pool, options, ignoreCache);
        }
        else if (alphafi_sdk_1.poolInfo[key].parentProtocolName === "NAVI" ||
            alphafi_sdk_1.poolInfo[key].parentProtocolName == "BUCKET" ||
            alphafi_sdk_1.poolInfo[key].parentProtocolName === "ALPHALEND") {
            poolPortfolio = await getSingleAssetPortfolioAmountInUSD(pool, options, ignoreCache);
        }
        if (poolPortfolio) {
            portfolioTotal = portfolioTotal.add(poolPortfolio);
        }
    }
    return portfolioTotal.toString();
}
async function getPortfolioAmountInUSD(poolName, options, ignoreCache) {
    if (Object.keys(alphafi_sdk_1.doubleAssetPoolCoinMap).includes(poolName)) {
        const amounts = await getPortfolioAmount(poolName, options, ignoreCache);
        if (amounts) {
            const ten = new decimal_js_1.Decimal(10);
            const pool1 = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1;
            const pool2 = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2;
            const amount0 = new decimal_js_1.Decimal(amounts[0]).div(ten.pow(alphafi_sdk_1.coinsList[pool1].expo));
            const amount1 = new decimal_js_1.Decimal(amounts[1]).div(ten.pow(alphafi_sdk_1.coinsList[pool2].expo));
            // const tokens = poolName.split("-");
            const [priceOfCoin0, priceOfCoin1] = await (0, alphafi_sdk_1.getLatestPrices)([`${pool1}/USD`, `${pool2}/USD`], ignoreCache);
            if (priceOfCoin0 && priceOfCoin1) {
                const amount = amount0.mul(priceOfCoin0).add(amount1.mul(priceOfCoin1));
                return amount.toString();
            }
        }
        else {
            console.error(`getPortfolioAmountInUSD is not implemented for poolName: ${poolName}`);
        }
        return "0";
    }
}
async function getSingleAssetPortfolioAmountInUSD(poolName, options, ignoreCache) {
    const amounts = await getSingleAssetPortfolioAmount(poolName, options, ignoreCache);
    if (amounts !== undefined) {
        const coinName = alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin;
        const amount = new decimal_js_1.Decimal(amounts).div(new decimal_js_1.Decimal(Math.pow(10, alphafi_sdk_1.coinsList[coinName].expo)));
        const [priceOfCoin] = await (0, alphafi_sdk_1.getLatestPrices)([`${coinName}/USD`], ignoreCache);
        if (priceOfCoin) {
            const amountInUSD = amount.mul(priceOfCoin);
            return amountInUSD.toString();
        }
    }
    else {
        console.error(`getSingleAssetPortfolioAmountInUSD is not implemented for poolName: ${poolName}`);
    }
    return "0";
}
async function getSingleAssetPortfolioAmount(poolName, options, ignoreCache) {
    let portfolioAmount = 0;
    const receipts = await (0, alphafi_sdk_1.getReceipts)(poolName, options.address, ignoreCache);
    let totalXTokens = new decimal_js_1.Decimal(0);
    if (receipts) {
        receipts.forEach((receipt) => {
            const xTokens = receipt.content.fields.xTokenBalance;
            totalXTokens = totalXTokens.add(xTokens);
        });
    }
    if (totalXTokens.gt(0)) {
        let pool;
        let investor;
        try {
            if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName == "NAVI" ||
                alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "ALPHALEND") {
                pool = await (0, alphafi_sdk_1.getPool)(poolName, ignoreCache);
                investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, ignoreCache));
            }
        }
        catch (e) {
            console.error(e);
        }
        if (poolName == "NAVI-LOOP-USDC-USDT" ||
            poolName == "NAVI-LOOP-USDT-USDC") {
            const supplyCoin = alphafi_sdk_1.loopingPoolCoinMap[poolName].supplyCoin;
            const borrowCoin = alphafi_sdk_1.loopingPoolCoinMap[poolName].borrowCoin;
            if (pool && investor) {
                let tokensInvested = new decimal_js_1.Decimal(0);
                const currentDebt = await getNaviLoopingPoolDebt(poolName, ignoreCache);
                const currentSupply = investor.content.fields.tokensDeposited.toString();
                if (alphafi_sdk_1.cetusPoolMap[supplyCoin + "-" + borrowCoin] &&
                    currentDebt &&
                    currentSupply) {
                    const cetusPool = await (0, alphafi_sdk_1.getCetusPool)(supplyCoin + "-" + borrowCoin, false);
                    if (cetusPool) {
                        const sqrtPrice = cetusPool?.content.fields.current_sqrt_price;
                        const price = cetus_sui_clmm_sdk_1.TickMath.sqrtPriceX64ToPrice(new bn_js_1.default(sqrtPrice), alphafi_sdk_1.coinsList[supplyCoin].expo, alphafi_sdk_1.coinsList[borrowCoin].expo);
                        const currentDebtInSupplyCoin = new decimal_js_1.Decimal(currentDebt).div(price);
                        tokensInvested = new decimal_js_1.Decimal(currentSupply).minus(currentDebtInSupplyCoin);
                    }
                    else {
                        console.error(`couldnt fetch cetus pool`);
                    }
                }
                else if (alphafi_sdk_1.cetusPoolMap[borrowCoin + "-" + supplyCoin] &&
                    currentDebt !== undefined &&
                    currentSupply !== undefined) {
                    const cetusPool = await (0, alphafi_sdk_1.getCetusPool)(borrowCoin + "-" + supplyCoin, false);
                    if (cetusPool) {
                        const sqrtPrice = cetusPool?.content.fields.current_sqrt_price;
                        const price = cetus_sui_clmm_sdk_1.TickMath.sqrtPriceX64ToPrice(new bn_js_1.default(sqrtPrice), alphafi_sdk_1.coinsList[borrowCoin].expo, alphafi_sdk_1.coinsList[supplyCoin].expo);
                        const currentDebtInSupplyCoin = new decimal_js_1.Decimal(currentDebt).mul(price);
                        tokensInvested = new decimal_js_1.Decimal(currentSupply).minus(currentDebtInSupplyCoin);
                    }
                    else {
                        console.error(`couldnt fetch cetus pool`);
                    }
                }
                else {
                    console.error(`one or more of these are possibly undefined: currentDebt:${currentDebt}, currentSupply: ${currentSupply}, cetusPoolMap[supplyCoin+'-'+borrowCoin]:${alphafi_sdk_1.cetusPoolMap[supplyCoin + "-" + borrowCoin]}, cetusPoolMap[borrowCoin+'-'+supplyCoin]: ${alphafi_sdk_1.cetusPoolMap[borrowCoin + "-" + supplyCoin]}`);
                }
                const xTokenSupplyInPool = new decimal_js_1.Decimal(pool.content.fields.xTokenSupply);
                const userTokens = totalXTokens
                    .mul(tokensInvested)
                    .div(xTokenSupplyInPool);
                const tokens = userTokens.div(Math.pow(10, 9 - alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].expo));
                portfolioAmount = Number(tokens);
            }
            else {
                console.error(`Could not get object for poolName: ${poolName}`);
            }
        }
        else if (poolName == "NAVI-LOOP-HASUI-SUI" ||
            poolName == "NAVI-LOOP-SUI-VSUI" ||
            poolName === "ALPHALEND-LOOP-SUI-STSUI" ||
            poolName === "ALPHALEND-SINGLE-LOOP-TBTC" ||
            poolName === "ALPHALEND-SINGLE-LOOP-SUIBTC" ||
            poolName === "ALPHALEND-SINGLE-LOOP-XAUM") {
            if (pool && investor) {
                const liquidity = new decimal_js_1.Decimal(investor.content.fields.tokensDeposited);
                const debtToSupplyRatio = new decimal_js_1.Decimal(investor.content.fields.current_debt_to_supply_ratio);
                const tokensInvested = liquidity.mul(new decimal_js_1.Decimal(1).minus(new decimal_js_1.Decimal(debtToSupplyRatio).div(1e20)));
                const xTokenSupplyInPool = new decimal_js_1.Decimal(pool.content.fields.xTokenSupply);
                const userTokens = totalXTokens
                    .mul(tokensInvested)
                    .div(xTokenSupplyInPool);
                let tokens = userTokens;
                if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "NAVI") {
                    tokens = userTokens.div(Math.pow(10, 9 - alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].expo));
                }
                if (poolName == "NAVI-LOOP-SUI-VSUI") {
                    // const { SevenKGateway } = await import("../");
                    // const sevenKInstance = new SevenKGateway();
                    // const numberOfTokensInSui = (await sevenKInstance.getQuote({
                    //   slippage: 1,
                    //   senderAddress: options.address,
                    //   pair: { coinA: coins["VSUI"], coinB: coins["SUI"] },
                    //   inAmount: new BN(tokens.toNumber()),
                    // })) as QuoteResponse;
                    const voloExchRate = await (0, alphafi_sdk_1.fetchVoloExchangeRate)(ignoreCache);
                    portfolioAmount = Number(tokens.mul(parseFloat(voloExchRate.data.exchangeRate)));
                }
                else if (poolName == "ALPHALEND-LOOP-SUI-STSUI") {
                    // const { SevenKGateway } = await import("../");
                    // const sevenKInstance = new SevenKGateway();
                    // const numberOfTokensInSui = (await sevenKInstance.getQuote({
                    //   slippage: 1,
                    //   senderAddress: options.address,
                    //   pair: { coinA: coins["VSUI"], coinB: coins["SUI"] },
                    //   inAmount: new BN(tokens.toNumber()),
                    // })) as QuoteResponse;
                    const suiTostSuiExchangeRate = await (0, stsui_sdk_1.stSuiExchangeRate)((0, stsui_sdk_1.getConf)().LST_INFO, ignoreCache);
                    portfolioAmount = Number(tokens.mul(suiTostSuiExchangeRate));
                }
                else {
                    portfolioAmount = Number(tokens);
                }
            }
            else {
                console.error(`Could not get object for poolName: ${poolName}`);
            }
        }
        else {
            const poolExchangeRate = await getPoolExchangeRate(poolName, ignoreCache);
            if (poolExchangeRate) {
                let tokens = totalXTokens.mul(poolExchangeRate);
                if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName == "NAVI") {
                    tokens = tokens.div(Math.pow(10, 9 - alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].expo));
                }
                portfolioAmount = tokens.toNumber();
            }
            else {
                console.error(`Could not get poolExchangeRate for poolName: ${poolName}`);
            }
        }
    }
    return portfolioAmount;
}
const naviLoopingPoolDebtCache = new simpleCache_js_1.SimpleCache();
async function getNaviLoopingPoolDebt(poolName, ignoreCache) {
    try {
        const naviLoopingPoolDebtCacheKey = `naviLoopingPoolDebt-${poolName}`;
        if (ignoreCache) {
            naviLoopingPoolDebtCache.delete(naviLoopingPoolDebtCacheKey);
        }
        const cachedResponse = naviLoopingPoolDebtCache.get(naviLoopingPoolDebtCacheKey);
        if (cachedResponse) {
            return cachedResponse;
        }
        const debt = (await (0, alphafi_sdk_1.getSuiClient)().getDynamicFieldObject({
            parentId: alphafi_sdk_1.poolInfo[poolName].investorId,
            name: {
                type: "vector<u8>",
                value: "debt".split("").map((char) => char.charCodeAt(0)),
            },
        })).data.content.fields.value.toString();
        naviLoopingPoolDebtCache.set(naviLoopingPoolDebtCacheKey, debt);
        return debt;
    }
    catch (e) {
        console.error("error in fetching naviLoopingPoolDebt", e);
        return "0";
    }
}
async function getPortfolioAmount(poolName, options, ignoreCache) {
    let portfolioAmount = ["0", "0"];
    let totalXTokens = new decimal_js_1.Decimal(0);
    if (poolName.toString().includes("-FUNGIBLE-")) {
        const tokenBalance = await getTokenBalance(alphafi_sdk_1.poolInfo[poolName].receiptName, { address: options.address }, ignoreCache);
        if (tokenBalance) {
            totalXTokens = new decimal_js_1.Decimal(tokenBalance);
        }
        else {
            console.error("could not fetch fungible token balance for getPortfolioAmount");
        }
    }
    else {
        const receipts = await (0, alphafi_sdk_1.getReceipts)(poolName, options.address, ignoreCache);
        if (receipts && receipts.length > 0) {
            const xTokens = receipts[0].content.fields.xTokenBalance;
            totalXTokens = totalXTokens.add(xTokens);
        }
    }
    if (totalXTokens.gt(0)) {
        const poolExchangeRate = await getPoolExchangeRate(poolName, ignoreCache);
        if (poolExchangeRate) {
            const tokens = totalXTokens.mul(poolExchangeRate);
            const poolTokenAmounts = await (0, alphafi_sdk_1.getCoinAmountsFromLiquidity)(poolName, tokens.toString(), ignoreCache);
            if (alphafi_sdk_1.poolInfo[poolName].strategyType === "LEVERAGE-YIELD-FARMING") {
                const investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, ignoreCache));
                if (investor) {
                    poolTokenAmounts[0] = new decimal_js_1.Decimal(poolTokenAmounts[0])
                        .mul(new decimal_js_1.Decimal(1).minus(new decimal_js_1.Decimal(investor.content.fields.current_debt_to_supply_ratio.fields.value).div(Math.pow(10, 18))))
                        .toString();
                    poolTokenAmounts[1] = new decimal_js_1.Decimal(poolTokenAmounts[1])
                        .mul(new decimal_js_1.Decimal(1).minus(new decimal_js_1.Decimal(investor.content.fields.current_debt_to_supply_ratio.fields.value).div(Math.pow(10, 18))))
                        .toString();
                }
                else {
                    console.error("lyf investor not found");
                }
            }
            portfolioAmount = poolTokenAmounts;
        }
        else {
            console.error(`Could not get poolExchangeRate for poolName: ${poolName}`);
        }
    }
    return portfolioAmount;
}
function getExchangeRate(pool) {
    const exchangeRate = Number(pool.content.fields.tokensInvested) /
        Number(pool.content.fields.xTokenSupply);
    return exchangeRate;
}
async function getAlphaPortfolioAmount(poolName, options, ignoreCache) {
    const receipts = await (0, alphafi_sdk_1.getReceipts)(poolName, options.address, ignoreCache);
    const pool = await (0, alphafi_sdk_1.getPool)(poolName, ignoreCache);
    if (!pool) {
        throw new Error("Pool not found");
    }
    const exchangeRate = await getPoolExchangeRate(poolName, ignoreCache);
    if (!exchangeRate || receipts.length <= 0) {
        return "0"; // if pool has 0 xtokens
    }
    const totalXTokens = new decimal_js_1.Decimal(receipts[0].content.fields.xTokenBalance);
    const lockedBalances = await (0, index_js_1.fetchUserLockedBalances)(options, ignoreCache);
    let lockedXtokens = new decimal_js_1.Decimal(0);
    const currentTime = Date.now();
    for (const entry of lockedBalances) {
        const xToken = new decimal_js_1.Decimal(entry.xTokenBalance);
        if (currentTime < Number(entry.timestamp)) {
            lockedXtokens = lockedXtokens.add(xToken);
        }
    }
    let xTokens = new decimal_js_1.Decimal(0);
    if (options.isLocked === true) {
        xTokens = lockedXtokens;
    }
    else if (options.isLocked === false) {
        xTokens = totalXTokens.sub(lockedXtokens);
    }
    else {
        xTokens = totalXTokens;
    }
    if (xTokens.gt(0)) {
        const poolExchangeRate = await getPoolExchangeRate(poolName, ignoreCache);
        if (poolExchangeRate) {
            const tokens = xTokens.mul(poolExchangeRate).div(1e9);
            return `${tokens}`;
        }
        else {
            console.error(`Could not get poolExchangeRate for poolName: ${poolName}`);
        }
    }
    else {
        return "0";
    }
}
async function getCurrentCetusPoolPrice(ignoreCache) {
    const res = new Map();
    for (const poolNameString of Object.keys(alphafi_sdk_1.poolInfo)) {
        const poolName = poolNameString;
        if (alphafi_sdk_1.poolInfo[poolName].poolId === "" ||
            poolName == "ALPHA" ||
            !["CETUS", "BLUEFIN"].includes(alphafi_sdk_1.poolInfo[poolNameString].parentProtocolName)) {
            continue;
        }
        let clmmPool;
        if (alphafi_sdk_1.poolInfo[poolNameString].parentProtocolName == "CETUS") {
            clmmPool = await (0, alphafi_sdk_1.getCetusPool)(poolName, ignoreCache);
        }
        else {
            clmmPool = await (0, alphafi_sdk_1.getParentPool)(poolName, ignoreCache);
        }
        const coinAName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1;
        const coinA = alphafi_sdk_1.coinsList[coinAName];
        const coinBName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2;
        const coinB = alphafi_sdk_1.coinsList[coinBName];
        if (clmmPool) {
            const currentSqrtPrice = clmmPool.content.fields.current_sqrt_price;
            const price = cetus_sui_clmm_sdk_1.TickMath.sqrtPriceX64ToPrice(new bn_js_1.default(currentSqrtPrice), coinA.expo, coinB.expo);
            res.set(poolName, price.toString());
        }
    }
    return res;
}
async function getPositionRange(ignoreCache) {
    const res = new Map();
    for (const poolNameString of Object.keys(alphafi_sdk_1.poolInfo)) {
        const poolName = poolNameString;
        if (poolName == "ALPHA" ||
            !["CETUS", "BLUEFIN"].includes(alphafi_sdk_1.poolInfo[poolNameString].parentProtocolName) ||
            !alphafi_sdk_1.poolInfo[poolName].poolId) {
            continue;
        }
        try {
            let investor;
            if (alphafi_sdk_1.poolInfo[poolNameString].parentProtocolName == "CETUS") {
                investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, ignoreCache));
            }
            else {
                investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, ignoreCache));
            }
            const coinAName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1;
            const coinA = alphafi_sdk_1.coinsList[coinAName];
            const coinBName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2;
            const coinB = alphafi_sdk_1.coinsList[coinBName];
            if (investor) {
                const upperBound = 443636;
                let lowerTick = Number(investor.content.fields.lower_tick);
                let upperTick = Number(investor.content.fields.upper_tick);
                if (lowerTick > upperBound) {
                    lowerTick = -~(lowerTick - 1);
                }
                if (upperTick > upperBound) {
                    upperTick = -~(upperTick - 1);
                }
                const lowerPrice = cetus_sui_clmm_sdk_1.TickMath.tickIndexToPrice(lowerTick, coinA.expo, coinB.expo);
                const upperPrice = cetus_sui_clmm_sdk_1.TickMath.tickIndexToPrice(upperTick, coinA.expo, coinB.expo);
                res.set(poolName, {
                    lowerPrice: lowerPrice.toString(),
                    upperPrice: upperPrice.toString(),
                });
            }
        }
        catch (error) {
            console.log("error", error);
            res.set(poolName, {
                lowerPrice: "0",
                upperPrice: "0",
            });
        }
    }
    return res;
}
async function getAlphaPortfolioAmountInUSD(poolName, options, ignoreCache) {
    const tokens = await getAlphaPortfolioAmount(poolName, options, ignoreCache);
    const [priceOfAlpha] = await (0, alphafi_sdk_1.getLatestPrices)(["ALPHA/USD"], ignoreCache);
    if (priceOfAlpha && tokens) {
        let amount = new decimal_js_1.Decimal(tokens);
        amount = amount.mul(priceOfAlpha);
        return amount.toString();
    }
}
async function getTotalAlphaRewardAmount(options, ignoreCache) {
    let totalAlphaReward = new decimal_js_1.Decimal(0);
    for (const key of Object.keys(alphafi_sdk_1.poolInfo)) {
        const poolName = key;
        if (alphafi_sdk_1.poolInfo[poolName].poolId === "" ||
            poolName == "ALPHA" ||
            poolName.toString().includes("-FUNGIBLE-")) {
            continue;
        }
        const alphaReward = await getAlphaRewardAmount(poolName, options, ignoreCache);
        if (alphaReward) {
            totalAlphaReward = totalAlphaReward.plus(alphaReward);
        }
    }
    totalAlphaReward = totalAlphaReward.div(1000000000);
    return `${totalAlphaReward}`;
}
async function getAlphaRewardAmount(poolName, options, ignoreCache) {
    let alphaReward = new decimal_js_1.Decimal(0);
    const receipts = await (0, alphafi_sdk_1.getReceipts)(poolName, options.address, ignoreCache);
    for (let i = 0; i < receipts.length; i++) {
        const receipt = receipts[i];
        let userPendingRewards = new decimal_js_1.Decimal(0);
        const userXtokenBalance = receipt.content.fields.xTokenBalance;
        let poolRewards = new decimal_js_1.Decimal(0);
        const currentTime = new decimal_js_1.Decimal(Date.now());
        const distributor = await (0, alphafi_sdk_1.getDistributor)(ignoreCache);
        const members = distributor?.content.fields.pool_allocator.fields.members.fields.contents;
        const unlockPerMS = new decimal_js_1.Decimal(distributor.content.fields.target)
            .mul(new decimal_js_1.Decimal(2750000))
            .div(new decimal_js_1.Decimal(4250000)
            .mul(new decimal_js_1.Decimal(100))
            .mul(new decimal_js_1.Decimal((0, alphafi_sdk_1.getConf)().MS_IN_A_DAY)));
        let lastUpdateTime = new decimal_js_1.Decimal(0);
        let pendingRewardsInAllocator = new decimal_js_1.Decimal(0);
        let weight = new decimal_js_1.Decimal(0);
        let totalWeight = new decimal_js_1.Decimal(0);
        let curAcc = new decimal_js_1.Decimal(0);
        let lastAcc = new decimal_js_1.Decimal(0);
        let totalXtokenSupply = new decimal_js_1.Decimal(0);
        const totalWeights = distributor?.content.fields.pool_allocator.fields.total_weights.fields
            .contents;
        const userPendingRewardsAll = receipt.content.fields.pending_rewards.fields.contents;
        for (let i = 0; i < userPendingRewardsAll.length; i++) {
            if (userPendingRewardsAll[i].fields.key.fields.name ==
                alphafi_sdk_1.coinsList["ALPHA"].type.substring(2)) {
                userPendingRewards = userPendingRewards.plus(new decimal_js_1.Decimal(userPendingRewardsAll[i].fields.value));
                break;
            }
        }
        totalWeights?.forEach((reward) => {
            if (reward.fields.key.fields.name == alphafi_sdk_1.coinsList["ALPHA"].type.substring(2)) {
                totalWeight = new decimal_js_1.Decimal(reward.fields.value);
            }
        });
        members?.forEach((member) => {
            if (member.fields.key == alphafi_sdk_1.poolInfo[poolName].poolId) {
                const poolData = member.fields.value.fields.pool_data.fields.contents;
                poolData.forEach((entry) => {
                    if (entry.fields.key.fields.name == alphafi_sdk_1.coinsList["ALPHA"].type.substring(2)) {
                        lastUpdateTime = new decimal_js_1.Decimal(entry.fields.value.fields.last_update_time);
                        pendingRewardsInAllocator = new decimal_js_1.Decimal(entry.fields.value.fields.pending_rewards);
                        weight = new decimal_js_1.Decimal(entry.fields.value.fields.weight);
                    }
                });
            }
        });
        try {
            const pool = await (0, alphafi_sdk_1.getPool)(poolName, ignoreCache);
            if (pool !== undefined) {
                totalXtokenSupply = new decimal_js_1.Decimal(pool.content.fields.xTokenSupply);
                const currAccForAllRewards = pool.content.fields.acc_rewards_per_xtoken.fields.contents;
                currAccForAllRewards?.forEach((reward) => {
                    if (reward.fields.key.fields.name ==
                        alphafi_sdk_1.coinsList["ALPHA"].type.substring(2)) {
                        curAcc = new decimal_js_1.Decimal(reward.fields.value);
                    }
                });
            }
            else {
                totalXtokenSupply = new decimal_js_1.Decimal(0);
                curAcc = new decimal_js_1.Decimal(0);
            }
            const lastAccAll = receipt.content.fields.last_acc_reward_per_xtoken.fields.contents;
            lastAccAll.forEach((reward) => {
                if (reward.fields.key.fields.name == alphafi_sdk_1.coinsList["ALPHA"].type.substring(2)) {
                    lastAcc = new decimal_js_1.Decimal(reward.fields.value);
                }
            });
            if (totalWeight > new decimal_js_1.Decimal(0) && totalXtokenSupply > new decimal_js_1.Decimal(0)) {
                poolRewards = pendingRewardsInAllocator.plus(currentTime
                    .minus(lastUpdateTime)
                    .mul(unlockPerMS)
                    .mul(weight)
                    .div(totalWeight));
                curAcc = curAcc.plus(poolRewards
                    .mul(new decimal_js_1.Decimal((0, alphafi_sdk_1.getConf)().HALF_MUL))
                    .mul((0, alphafi_sdk_1.getConf)().HALF_MUL)
                    .div(totalXtokenSupply));
                alphaReward = alphaReward.plus(new decimal_js_1.Decimal(curAcc.minus(lastAcc).mul(userXtokenBalance))
                    .div((0, alphafi_sdk_1.getConf)().HALF_MUL)
                    .div((0, alphafi_sdk_1.getConf)().HALF_MUL));
                alphaReward = alphaReward.plus(new decimal_js_1.Decimal(userPendingRewards));
            }
        }
        catch (e) {
            console.error("error in getAlphaRewardAmount", e);
        }
    }
    return `${alphaReward}`;
}
const tokenBalanceCache = new simpleCache_js_1.SimpleCache(60000);
const tokenBalancePromiseCache = new simpleCache_js_1.SimpleCache(60000);
async function getMultiTokenBalance(options) {
    const suiClient = (0, alphafi_sdk_1.getSuiClient)();
    const coinNames = Object.keys(alphafi_sdk_1.coinsList);
    const coinTypes = coinNames.map((coinName) => {
        return alphafi_sdk_1.coinsList[coinName].type;
    });
    try {
        const res = await suiClient.getAllBalances({
            owner: options.address,
        });
        const resMap = new Map();
        res.forEach((enrty) => {
            let cointype = enrty.coinType;
            if (cointype === "0x2::sui::SUI") {
                cointype = alphafi_sdk_1.coinsList["SUI"].type;
            }
            resMap.set(cointype, enrty.totalBalance);
        });
        for (const coinType of coinTypes) {
            const cacheKey = `tokenBalance-${options.address}-${coinType}`;
            const value = resMap.get(coinType);
            if (value) {
                tokenBalanceCache.set(cacheKey, value);
            }
            else {
                tokenBalanceCache.set(cacheKey, "0");
            }
        }
    }
    catch (error) {
        console.error("Error fetching tokenBalances!");
    }
}
async function getTokenBalance(tokenName, options, ignoreCache) {
    const suiClient = (0, alphafi_sdk_1.getSuiClient)();
    const cacheKey = `tokenBalance-${options.address}-${alphafi_sdk_1.coinsList[tokenName].type}`;
    if (ignoreCache) {
        tokenBalanceCache.delete(cacheKey);
        tokenBalancePromiseCache.delete(cacheKey);
    }
    // Check if the investor is already in the cache
    const cachedBalance = tokenBalanceCache.get(cacheKey);
    if (cachedBalance) {
        return cachedBalance;
    }
    // Check if there is already a promise in the cache
    let cacheBalancePromise = tokenBalancePromiseCache.get(cacheKey);
    if (cacheBalancePromise) {
        return cacheBalancePromise;
    }
    cacheBalancePromise = (async () => {
        let balance = "0";
        try {
            if (options.address) {
                const coinBalance = await suiClient.getBalance({
                    owner: options.address,
                    coinType: alphafi_sdk_1.coinsList[tokenName].type,
                });
                const balanceInt = parseInt(coinBalance.totalBalance);
                balance = `${balanceInt}`;
            }
            tokenBalanceCache.set(cacheKey, balance);
            return balance;
        }
        catch (e) {
            console.error(`Could not get Balance for token: ${tokenName}`);
        }
        finally {
            // Remove the promise from the cache after it resolves
            tokenBalancePromiseCache.delete(cacheKey);
        }
    })();
    tokenBalancePromiseCache.set(cacheKey, cacheBalancePromise);
    return cacheBalancePromise;
}
async function getPoolExchangeRate(poolName, ignoreCache) {
    try {
        const pool = await (0, alphafi_sdk_1.getPool)(poolName, ignoreCache);
        if (pool) {
            let xTokenSupply = new decimal_js_1.Decimal(0);
            if (poolName.toString().includes("-FUNGIBLE-") &&
                "treasury_cap" in pool.content.fields) {
                xTokenSupply = new decimal_js_1.Decimal(pool.content.fields.treasury_cap.fields.total_supply.fields.value);
            }
            else {
                xTokenSupply = new decimal_js_1.Decimal(pool.content.fields.xTokenSupply);
            }
            let tokensInvested = new decimal_js_1.Decimal(pool.content.fields.tokensInvested);
            if (poolName == "ALPHA") {
                tokensInvested = new decimal_js_1.Decimal(pool.content.fields.alpha_bal);
            }
            else if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName == "CETUS") {
                const investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, ignoreCache));
                if (!investor) {
                    throw new Error(`couldnt fetch investor object for pool: ${poolName}`);
                }
                tokensInvested = new decimal_js_1.Decimal(pool.content.fields.tokensInvested);
            }
            // Check for division by zero
            if (xTokenSupply.eq(0)) {
                console.error("Division by zero error: tokensInvested is zero.");
                return undefined;
            }
            const poolExchangeRate = tokensInvested.div(xTokenSupply);
            return poolExchangeRate;
        }
    }
    catch (e) {
        console.log(`getPoolExchangeRate failed for poolName: ${poolName}, with error ${e}`);
    }
    return undefined;
}
async function collectRewardAndStakeAlpha() { }
/**
 * Converts APR to APY with compounding 6 times a day
 * @param apr - The annual percentage rate (APR) as a decimal
 * @returns The annual percentage yield (APY) as a decimal
 */
function convertAprToApy(apr) {
    const n = 6 * 365; // 6 times a day
    const apy = 100 * (Math.pow(1 + apr / 100 / n, n) - 1);
    return apy;
}
async function fetchBucketTVL(poolName, ignoreCache = false) {
    if (poolName == "BUCKET-BUCK") {
        try {
            const suiClient = (0, alphafi_sdk_1.getSuiClient)();
            const fountain = (await suiClient.getObject({
                id: (0, alphafi_sdk_1.getConf)().FOUNTAIN,
                options: { showContent: true },
            })).data;
            const flask = (await suiClient.getObject({
                id: (0, alphafi_sdk_1.getConf)().FLASK,
                options: { showContent: true },
            })).data;
            const totalSbuckInFountain = fountain.content.fields.staked;
            const buckPerSbuck = new decimal_js_1.Decimal(flask.content.fields.reserves).div(flask.content.fields.sbuck_supply.fields.value);
            const totalBuckInFountain = new decimal_js_1.Decimal(totalSbuckInFountain).mul(buckPerSbuck);
            const [buckPrice] = await (0, alphafi_sdk_1.getLatestPrices)(["BUCK/USD"], ignoreCache);
            return totalBuckInFountain
                .div(new decimal_js_1.Decimal(1e9))
                .mul(new decimal_js_1.Decimal(buckPrice))
                .toString();
        }
        catch {
            console.error("error in bucket protocol tvl");
            return "0";
        }
    }
    return "0";
}
const naviTVLCache = new simpleCache_js_1.SimpleCache();
const naviTVLPromiseCache = new simpleCache_js_1.SimpleCache();
async function fetchNaviTVL(poolName, ignoreCache = false) {
    // const coinName = singleAssetPoolCoinMap[poolName].coinName;
    const naviTVLUrl = "https://api.alphafi.xyz/navi-params";
    let poolData = {
        poolName: "NAVI-SUI",
        naviPoolTVL: "1000000",
    };
    if (ignoreCache) {
        naviTVLCache.clear();
        naviTVLPromiseCache.delete(naviTVLUrl);
    }
    const cachedResponse = naviTVLCache.get(naviTVLUrl);
    if (cachedResponse) {
        const poolDataObj = cachedResponse.find((pool) => pool.poolName === poolName);
        if (poolDataObj) {
            poolData = poolDataObj;
        }
    }
    else {
        try {
            let cachedPromise = naviTVLPromiseCache.get(naviTVLUrl);
            if (!cachedPromise) {
                cachedPromise = fetch(naviTVLUrl)
                    .then(async (response) => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    const data = (await response.json()); // Parse the JSON response
                    naviTVLCache.set(naviTVLUrl, data); // Cache the response
                    naviTVLPromiseCache.delete(naviTVLUrl); // Remove the promise from the cache
                    return data;
                })
                    .catch((error) => {
                    console.log("in error state");
                    naviTVLPromiseCache.delete(naviTVLUrl); // Ensure the promise is removed on error
                    throw error;
                });
                naviTVLPromiseCache.set(naviTVLUrl, cachedPromise);
                const poolTVLData = await cachedPromise;
                const naviPoolData = poolTVLData.find((pool) => pool.poolName === poolName);
                // poolData = naviPoolData;
                if (naviPoolData) {
                    poolData = naviPoolData;
                }
            }
            else {
                const poolDataArray = Promise.resolve(cachedPromise);
                const poolTVLData = await poolDataArray;
                const naviPoolData = poolTVLData.find((pool) => pool.poolName === poolName);
                if (naviPoolData) {
                    poolData = naviPoolData;
                }
            }
        }
        catch (error) {
            console.log("err in navi", error);
        }
    }
    return poolData;
}
async function fetchAlphalendTVL(poolName, ignoreCache) {
    const coinType = alphafi_sdk_1.coinsList[alphafi_sdk_1.loopingPoolCoinMap[poolName].supplyCoin].type;
    const alphalendClient = new alphalend_sdk_1.AlphalendClient("mainnet", (0, alphafi_sdk_1.getSuiClient)());
    const markets = await fetchAlphalendMarkets(ignoreCache);
    if (!markets) {
        console.error("couldnt fetch markets from alphalend sdk");
        return "0";
    }
    const marketsData = await alphalendClient.getAllMarketsWithCachedMarkets(markets);
    if (!marketsData) {
        console.error("couldnt fetch markets data from alphalend sdk");
        return "0";
    }
    const [priceOfCoin] = await (0, alphafi_sdk_1.getLatestPrices)([`${alphafi_sdk_1.loopingPoolCoinMap[poolName].supplyCoin}/USD`], ignoreCache);
    if (!priceOfCoin) {
        console.error("couldnt fetch price of coin", coinType);
        return "0";
    }
    for (const market of marketsData) {
        if (market.coinType ===
            (alphafi_sdk_1.loopingPoolCoinMap[poolName].supplyCoin != "SUI"
                ? coinType
                : "0x2::sui::SUI")) {
            return market.totalBorrow
                .plus(market.availableLiquidity)
                .mul(priceOfCoin)
                .toString();
        }
    }
    return "0";
}
const protocolTVLcache = new simpleCache_js_1.SimpleCache();
async function fetchProtocolTVL(poolName, ignoreCache = false) {
    try {
        const protocolTVLCacheKey = `fetchProtocolTVL-${poolName}`;
        if (ignoreCache) {
            protocolTVLcache.delete(protocolTVLCacheKey);
        }
        const cachedResponse = protocolTVLcache.get(protocolTVLCacheKey);
        if (cachedResponse) {
            return cachedResponse;
        }
        if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "CETUS") {
            const pool = await (0, alphafi_sdk_1.getCetusPool)(poolName, ignoreCache);
            if (pool) {
                const amounts = [
                    pool.content.fields.coin_a,
                    pool.content.fields.coin_b,
                ];
                const pool1 = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1;
                const pool2 = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2;
                const [priceOfCoin0, priceOfCoin1] = await (0, alphafi_sdk_1.getLatestPrices)([
                    `${pool1}/USD`,
                    `${pool2}/USD`,
                ], ignoreCache);
                const coinAInUsd = (Number(amounts[0]) * Number(priceOfCoin0)) /
                    Math.pow(10, alphafi_sdk_1.coinsList[pool1].expo);
                const coinBInUsd = (Number(amounts[1]) * Number(priceOfCoin1)) /
                    Math.pow(10, alphafi_sdk_1.coinsList[pool2].expo);
                protocolTVLcache.set(protocolTVLCacheKey, (coinAInUsd + coinBInUsd).toString());
                return (coinAInUsd + coinBInUsd).toString();
            }
            else {
                console.error(`Cannot getCetusPool for PoolName: ${poolName}`);
                return "0";
            }
        }
        else if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "BLUEFIN") {
            const pool = await (0, alphafi_sdk_1.getParentPool)(poolName, ignoreCache);
            if (pool) {
                const amounts = [
                    pool.content.fields.coin_a,
                    pool.content.fields.coin_b,
                ];
                const pool1 = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1;
                const pool2 = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2;
                const [priceOfCoin0, priceOfCoin1] = await (0, alphafi_sdk_1.getLatestPrices)([
                    `${pool1}/USD`,
                    `${pool2}/USD`,
                ], ignoreCache);
                const coinAInUsd = (Number(amounts[0]) * Number(priceOfCoin0)) /
                    Math.pow(10, alphafi_sdk_1.coinsList[pool1].expo);
                const coinBInUsd = (Number(amounts[1]) * Number(priceOfCoin1)) /
                    Math.pow(10, alphafi_sdk_1.coinsList[pool2].expo);
                protocolTVLcache.set(protocolTVLCacheKey, (coinAInUsd + coinBInUsd).toString());
                return (coinAInUsd + coinBInUsd).toString();
            }
            else {
                console.error(`Cannot getParentPool for PoolName: ${poolName}`);
                return "0";
            }
        }
        else if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "NAVI") {
            const res = await fetchNaviTVL(poolName);
            protocolTVLcache.set(protocolTVLCacheKey, res.naviPoolTVL);
            return res.naviPoolTVL;
        }
        else if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "BUCKET") {
            const bucketTvl = await fetchBucketTVL(poolName, ignoreCache);
            protocolTVLcache.set(protocolTVLCacheKey, bucketTvl);
            return bucketTvl;
        }
        else if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "ALPHAFI") {
            const alphavTvl = await fetchTVL(poolName, ignoreCache);
            protocolTVLcache.set(protocolTVLCacheKey, alphavTvl);
            return alphavTvl;
        }
        else if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "ALPHALEND") {
            const res = await fetchAlphalendTVL(poolName, ignoreCache);
            protocolTVLcache.set(protocolTVLCacheKey, res);
            return res;
        }
        else {
            console.error(`Cannot getNaviPool for PoolName: ${poolName}`);
            return "0";
        }
    }
    catch (e) {
        console.error("error in fetchProtocolTVL", e);
        return "0";
    }
}
const circulationSupplyOfAlphaCache = new simpleCache_js_1.SimpleCache();
const circulationSupplyOfAlphaPromiseCache = new simpleCache_js_1.SimpleCache();
async function circulationSupplyOfAlpha(ignoreCache) {
    const apiUrl = "https://api.alphafi.xyz/alpha/circulation";
    let circulationSuppply;
    if (ignoreCache) {
        circulationSupplyOfAlphaCache.clear();
        circulationSupplyOfAlphaPromiseCache.delete(apiUrl);
    }
    const cachedResponse = circulationSupplyOfAlphaCache.get(apiUrl);
    if (cachedResponse) {
        circulationSuppply = cachedResponse;
    }
    else {
        let cachedPromise = circulationSupplyOfAlphaPromiseCache.get(apiUrl);
        if (!cachedPromise) {
            cachedPromise = fetch(apiUrl)
                .then(async (response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json(); // Parse the JSON response
                circulationSupplyOfAlphaCache.set(apiUrl, data); // Cache the response
                circulationSupplyOfAlphaPromiseCache.delete(apiUrl); // Remove the promise from the cache
                return data;
            })
                .catch((error) => {
                circulationSupplyOfAlphaPromiseCache.delete(apiUrl); // Ensure the promise is removed on error
                throw error;
            });
            circulationSupplyOfAlphaPromiseCache.set(apiUrl, cachedPromise);
        }
        circulationSuppply = await cachedPromise;
    }
    return circulationSuppply;
}
// const alphaFiTvlCache = new SimpleCache<{
//   alphafi: string;
//   stsui: string;
//   total: string;
// }>();
// const alphaFiTvlPromiseCache = new SimpleCache<
//   Promise<{ alphafi: string; stsui: string; total: string }>
// >();
// export async function fetchAlphaFiStSuiTotalTvl(ignoreCache: boolean): Promise<{
//   alphafi: string;
//   stsui: string;
//   total: string;
// }> {
//   const cacheKey = `alphafitvl`;
//   if (ignoreCache) {
//     alphaFiTvlCache.delete(cacheKey);
//     alphaFiTvlPromiseCache.delete(cacheKey);
//   }
//   const cachedTvl = alphaFiTvlCache.get(cacheKey);
//   if (cachedTvl) {
//     return cachedTvl;
//   }
//   let cachedTvlPromise = alphaFiTvlPromiseCache.get(cacheKey);
//   if (cachedTvlPromise) {
//     return cachedTvlPromise;
//   }
//   cachedTvlPromise = (async () => {
//     try {
//       const alphaFiTvl = await fetchTotalTVL(false);
//       const stSuiTvl = await stStuiCirculationSupply(
//         getStSuiConf().LST_INFO,
//         true,
//       );
//       const totalTvl = new Decimal(alphaFiTvl).add(stSuiTvl).toString();
//       const result = {
//         alphafi: alphaFiTvl,
//         stsui: stSuiTvl,
//         total: totalTvl,
//       };
//       alphaFiTvlCache.set(cacheKey, result);
//       return result;
//     } catch (e) {
//       console.error("Error fetching AlphaFi TVL:", e);
//       throw e;
//     } finally {
//       alphaFiTvlPromiseCache.delete(cacheKey);
//     }
//   })();
//   alphaFiTvlPromiseCache.set(cacheKey, cachedTvlPromise);
//   return cachedTvlPromise;
// }
const stsuiAprCache = new simpleCache_js_1.SimpleCache();
async function fetchStSuiApr(days, ignoreCache) {
    try {
        const stsuiAprCacheKey = `stsuiApr-${days}`;
        if (ignoreCache) {
            stsuiAprCache.delete(stsuiAprCacheKey);
        }
        const cachedResponse = stsuiAprCache.get(stsuiAprCacheKey);
        if (cachedResponse) {
            return cachedResponse;
        }
        const stsuiAPR = await (0, stsui_sdk_1.fetchStSuiAPR)(days);
        stsuiAprCache.set(stsuiAprCacheKey, stsuiAPR);
        return stsuiAPR;
    }
    catch (e) {
        console.error("error in fetching stsuiAPR", e);
        return "0";
    }
}
async function fetchLeverage(ignoreCache) {
    const leverageMap = {};
    for (const poolName of Object.keys(alphafi_sdk_1.poolInfo)) {
        if (!alphafi_sdk_1.poolInfo[poolName].poolId || !alphafi_sdk_1.poolInfo[poolName].investorId) {
            continue;
        }
        let leverage = new decimal_js_1.Decimal(0);
        const investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, ignoreCache));
        if (alphafi_sdk_1.poolInfo[poolName].strategyType === "LOOPING" ||
            alphafi_sdk_1.poolInfo[poolName].strategyType === "SINGLE-LOOPING") {
            leverage = new decimal_js_1.Decimal(investor.content.fields.current_debt_to_supply_ratio).div(1e18);
        }
        else if (alphafi_sdk_1.poolInfo[poolName].strategyType === "LEVERAGE-YIELD-FARMING") {
            leverage = new decimal_js_1.Decimal(investor.content.fields.current_debt_to_supply_ratio.fields.value).div(1e16);
        }
        leverageMap[poolName] = leverage.toString();
    }
    return leverageMap;
}
//# sourceMappingURL=index.js.map